import { useEffect, useState } from "react";
import { Box, Typography, Button, Stack, CircularProgress, Paper, Divider, Container, useTheme, Grid } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ShippingCategoriesTap from "./ShippingSegments/ShippingCategoriesTap";

const ShippingZonesAndStatesTab = () => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [error, setError] = useState("");

  const formatMoney = (v) => {
    if (v == null || v === "") return "-";
    const n = Number(v);
    if (Number.isNaN(n)) return v;
    return n.toFixed(2);
  };

  return (
    <Container maxWidth={false} sx={{ py: 2 }}>
      <Paper sx={{ p: 2, bgcolor: theme.palette.background.paper }}>
        {/* استخدم المكوّن المخصص لعرض شرائح الشحن (يتضمن جلب البيانات وحالة التحميل) */}
        <ShippingCategoriesTap />
      </Paper>
    </Container>
  );
};

export default ShippingZonesAndStatesTab;
